module.exports = __webpack_public_path__ + "img/account_qrcode.73940862.png";